import React, { createContext, useContext, useEffect, useState } from "react";

const SidebarContext = createContext(null);

const STORAGE_KEY = "sidebar_collapsed";
export const SIDEBAR_WIDTH = 256; // px, expanded (w-64)
export const SIDEBAR_WIDTH_COLLAPSED = 72; // px, collapsed

export function SidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
    } catch (e) {
      /* ignore */
    }
  }, [collapsed]);

  const toggle = () => setCollapsed((c) => !c);

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed, toggle }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  if (!ctx) {
    // Sensible default if used outside the provider
    return { collapsed: false, setCollapsed: () => {}, toggle: () => {} };
  }
  return ctx;
}
